export default __webpack_public_path__ + "static/media/img-27-guiden.9310868c.jpg";